import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, defer } from 'rxjs';
import { map, catchError, filter, switchMap, take } from 'rxjs/operators';
import { PharmacyDetails } from '@interfaces/pharmacy-details.model';
import { AuthStatus } from '@interfaces/auth-status.model';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PharmacyService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  public requestDetailsWhenAuthorized(): Observable<PharmacyDetails> {
    return this.getAuthStatus().pipe(
      take(1),
      switchMap((auth) => {
        return defer(() => {
          return !!auth ? this.getRxDetails() : of([]);
        });
      })
    );
  }

  private getRxDetails(): Observable<any> {
    return this.http
      .get('/api/rx_details.json', {
        withCredentials: true,
      })
      .pipe(
        map((data: PharmacyDetails) => new PharmacyDetails(data)),
        catchError((error) => of(false))
      );
  }

  private getAuthStatus(): Observable<boolean> {
    return this.authService.storeAuthStatus().pipe(
      filter((authStatus: AuthStatus) => authStatus.resolved),
      map((authStatus: AuthStatus) => authStatus.auth_status)
    );
  }
}
